var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoStWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 330.39 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_st_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "0 88.69 0 153.9 15.95 153.9 15.95 102.37 35.75 102.37 35.75 88.69 0 88.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.72,120.89a19.88,19.88,0,0,0,5.11,13.91,16.74,16.74,0,0,0,25,0,19.88,19.88,0,0,0,5.11-13.91,18.59,18.59,0,0,0-5.11-13.32,17.2,17.2,0,0,0-25,0,18.58,18.58,0,0,0-5.11,13.32m-16.5,0a31.94,31.94,0,0,1,9.72-23.71q9.7-9.57,24.4-9.57t24.4,9.57a32,32,0,0,1,9.72,23.71q0,14.49-9.72,24.3T74.34,155q-14.69,0-24.4-9.8t-9.72-24.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.29,129.91V88.69h16v41.22c0,3.35,1,5.93,3.05,7.76a13.83,13.83,0,0,0,16.5,0c2-1.83,3.06-4.41,3.06-7.76V88.69h16v41.22q0,11.13-7.48,18.1t-19.7,7q-12.32,0-19.84-7t-7.52-18.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.68,121.16q0-14.32,9.76-23.94t24.44-9.62a38.5,38.5,0,0,1,8.71,1,31.48,31.48,0,0,1,6.88,2.32q2.75,1.37,4.84,2.69a18.64,18.64,0,0,1,3.1,2.33l.91.91-7.38,12q-.83-.73-2.28-1.83a33.17,33.17,0,0,0-5.74-3,20.68,20.68,0,0,0-8.3-1.87q-8.84,0-13.63,5.47a19.27,19.27,0,0,0-4.79,13.13,20.73,20.73,0,0,0,4.93,13.73q4.92,5.88,13.49,5.88a20.63,20.63,0,0,0,8.71-2,23.71,23.71,0,0,0,6.43-4l2.19-2,8.21,11.67a15.39,15.39,0,0,1-1.09,1.19,39,39,0,0,1-3.24,2.6,38.27,38.27,0,0,1-5.34,3.33,37.33,37.33,0,0,1-7.34,2.65,36.28,36.28,0,0,1-9.26,1.18q-15.13,0-24.67-9.57t-9.54-24.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.73 153.9 255.73 88.69 271.69 88.69 271.69 114.77 295.4 114.77 295.4 88.69 311.36 88.69 311.36 153.9 295.4 153.9 295.4 128.36 271.69 128.36 271.69 153.9 255.73 153.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16,58.08,16.55,46c.55.48,1.31,1.11,2.29,1.87a30.84,30.84,0,0,0,5.56,3,18.71,18.71,0,0,0,7.76,1.87A9.08,9.08,0,0,0,37,51.46a4.28,4.28,0,0,0,2-4c0-1.16-.73-2.26-2.19-3.33a22.2,22.2,0,0,0-5.43-2.78,74.71,74.71,0,0,1-7.07-3,63.14,63.14,0,0,1-7.07-4,17.47,17.47,0,0,1-5.43-5.89A16.51,16.51,0,0,1,9.62,20a18,18,0,0,1,6.6-14.41Q22.84,0,32.68,0A33.83,33.83,0,0,1,44.13,1.87c3.5,1.25,5.94,2.47,7.34,3.69l2.19,1.83-6.75,13c-.48-.42-1.17-1-2-1.6a28.76,28.76,0,0,0-5.11-2.55,18.71,18.71,0,0,0-7.25-1.6A9,9,0,0,0,27.62,16a4.21,4.21,0,0,0-2.05,3.83q0,2.19,3,3.93a51,51,0,0,0,7.35,3.37,93.42,93.42,0,0,1,8.66,3.83,20.32,20.32,0,0,1,7.34,6.34,16.38,16.38,0,0,1,3,9.9,19,19,0,0,1-6.21,14.36Q42.54,67.4,32,67.4a35.51,35.51,0,0,1-8.3-1A30.58,30.58,0,0,1,17,64.12a51,51,0,0,1-4.79-2.74,15.59,15.59,0,0,1-3-2.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8,66.29,70.18,1.08H87.51L97,28.62l3.28,10.76h.18q1.83-6.57,3.29-10.76l9.49-27.54h17.33l5.29,65.21h-16l-2-29.37c-.12-1.45-.18-3.1-.18-4.92s0-3.29.09-4.38l.09-1.64h-.2Q115.5,32.82,114,36.92L107.2,55.8H93.52L86.68,36.92,83,26h-.18a79.68,79.68,0,0,1,0,10.94l-2,29.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.69,16h-.19c-1,4.74-1.86,8.48-2.64,11.21l-3.74,12.68H179l-3.64-12.68Zm14,50.34-4-13.68H162.37l-3.92,13.68H142L164.19,1.08H181l22.16,65.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.32,30.63h6.93a8.54,8.54,0,0,0,6.12-2.09,7.87,7.87,0,0,0,2.19-5.93c0-2.67-.71-4.65-2.1-5.93s-4-1.91-7.75-1.91h-5.38V30.63Zm-16,35.66V1.08h22.71q8.66,0,12.68,1.55A18.11,18.11,0,0,1,255.6,9.7a21.27,21.27,0,0,1,3.19,11.9A22.58,22.58,0,0,1,256.24,32,16.37,16.37,0,0,1,249,39.38v.18a35.11,35.11,0,0,1,2.46,3.92l12.68,22.8H246.39l-11.58-22h-7.48v22h-16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.24 66.29 287.24 14.76 267.45 14.76 267.45 1.08 303.2 1.08 303.2 66.29 287.24 66.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.1 7.85 319.1 2.14 316.88 2.14 316.88 1.08 322.55 1.08 322.55 2.14 320.33 2.14 320.33 7.85 319.1 7.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.31,7.85l.55-6.77h1.32l1.33,3.35.34,1h0c.12-.39.23-.73.33-1l1.33-3.35h1.32l.54,6.77h-1.22l-.29-3.79V3h0a10.27,10.27,0,0,1-.36,1l-1.1,2.62h-1.08l-1.09-2.62L324.85,3h0c0,.41,0,.76,0,1.06l-.29,3.79Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStWhite);
export default __webpack_public_path__ + "static/media/logo_st_white.3234907d82721a5b2d1bd98eb3e708e7.svg";
export { ForwardRef as ReactComponent };